import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'content-two-modal-desktop',
  templateUrl: './content-two-modal-desktop.component.html',
  styleUrls: ['./content-two-modal-desktop.component.scss'],
})
export class ContentTwoModalDesktopComponent implements OnInit {
  @Input() qr: string = '';
  @Input() text1!: string;
  @Input() text2!: string;
  @Input() tex3!: string;

  constructor() {}

  ngOnInit(): void {}
}
